var _defs, _rect, _g, _g2, _path, _path2, _path3, _g3, _path4, _path5, _path6, _g4, _path7, _path8, _path9, _g5, _path10, _path11, _path12, _g6, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmRanking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-ranking-dm-cls-1 {\n        clip-path: url(#dummy-widget-ranking-dm-clippath);\n      }\n\n      .dummy-widget-ranking-dm-cls-2 {\n        fill: none;\n      }\n\n      .dummy-widget-ranking-dm-cls-2, .dummy-widget-ranking-dm-cls-3, .dummy-widget-ranking-dm-cls-4, .dummy-widget-ranking-dm-cls-5, .dummy-widget-ranking-dm-cls-6, .dummy-widget-ranking-dm-cls-7, .dummy-widget-ranking-dm-cls-8 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-ranking-dm-cls-3 {\n        fill: #eaeaea;\n      }\n\n      .dummy-widget-ranking-dm-cls-4 {\n        opacity: .5;\n      }\n\n      .dummy-widget-ranking-dm-cls-4, .dummy-widget-ranking-dm-cls-9 {\n        isolation: isolate;\n      }\n\n      .dummy-widget-ranking-dm-cls-4, .dummy-widget-ranking-dm-cls-8 {\n        fill: #fff;\n      }\n\n      .dummy-widget-ranking-dm-cls-5 {\n        fill: #c2c1c1;\n      }\n\n      .dummy-widget-ranking-dm-cls-6 {\n        fill: #3364ae;\n      }\n\n      .dummy-widget-ranking-dm-cls-7 {\n        fill: #e6e6e5;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-ranking-dm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-dm-cls-2",
    x: 7.5,
    y: 7.7,
    width: 155.6,
    height: 155.6
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-dm-cls-3",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 8.4,
    ry: 8.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-ranking-dm-cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-4",
    d: "M151.4,8.1h88c3.8,0,6.8,3,6.8,6.8v58.6c0,3.7-3,6.8-6.8,6.8h-88c-3.8,0-6.8-3-6.8-6.8V14.9c0-3.7,3-6.8,6.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-4",
    d: "M151.4,90.4h88c3.8,0,6.8,3,6.8,6.8v58.6c0,3.7-3,6.8-6.8,6.8h-88c-3.8,0-6.8-3-6.8-6.8v-58.6c0-3.7,3-6.8,6.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-4",
    d: "M-65.5,8.1H19.4c3.8,0,6.8,3,6.8,6.8v141.6c0,3.7-3,6.8-6.8,6.8h-84.9c-3.8,0-6.8-3-6.8-6.8V14.9c0-3.7,3-6.8,6.8-6.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-8",
    d: "M45.6,8.1h80c3.8,0,6.8,3,6.8,6.8v141.3c0,3.7-3,6.8-6.8,6.8H45.6c-3.8,0-6.8-3-6.8-6.8V14.9c0-3.7,3-6.8,6.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-5",
    d: "M125.6,163.1H45.6c-3.9,0-7-3.2-7-7V14.9c0-3.9,3.2-7,7-7h79.9c3.9,0,7,3.2,7,7v141.3c0,3.9-3.2,7-7,7h0ZM45.6,8.3c-3.6,0-6.6,3-6.6,6.6v141.3c0,3.6,3,6.6,6.6,6.6h79.9c3.6,0,6.6-3,6.6-6.6V14.9c0-3.6-3-6.6-6.6-6.6H45.6Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-ranking-dm-cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-6",
    d: "M52,30h-1.4v-5.4l-1.7.5v-1.1l2.9-1h0v7h.1Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,20.3h33.2c1.5,0,2.7,1.2,2.7,2.6h0c0,1.5-1.2,2.6-2.7,2.6h-33.2c-1.5,0-2.7-1.2-2.7-2.6h0c0-1.5,1.2-2.6,2.7-2.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M116.8,20.3h4c1.5,0,2.7,1.2,2.7,2.6h0c0,1.5-1.2,2.6-2.7,2.6h-4c-1.5,0-2.7-1.2-2.7-2.6h0c0-1.5,1.2-2.6,2.7-2.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,29.1h33.2c1.5,0,2.7,1.2,2.7,2.6h0c0,1.5-1.2,2.7-2.7,2.7h-33.2c-1.5,0-2.7-1.2-2.7-2.6h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-ranking-dm-cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-6",
    d: "M53.4,58.9h-4.8v-1l2.3-2.4c.3-.3.5-.6.7-.9,0-.3.2-.5.2-.7s0-.6-.2-.7-.4-.3-.7-.3-.6,0-.7.3c-.2.2-.3.5-.3.9h-1.4c0-.4,0-.8.3-1.2s.5-.6.9-.8.8-.3,1.3-.3,1.3.2,1.7.5.6.8.6,1.5,0,.7-.3,1.1-.5.8-.9,1.3l-1.6,1.7h3v1.1h0Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,49.2h33.2c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.6-2.7,2.6h-33.2c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.6,2.7-2.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M116.8,49.2h4c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.6-2.7,2.6h-4c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.6,2.7-2.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,58h33.2c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.6-2.7,2.6h-33.2c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.6,2.7-2.6Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-ranking-dm-cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-6",
    d: "M50,84.8h.7c.4,0,.6,0,.8-.3.2-.2.3-.4.3-.7s0-.5-.3-.7c-.2-.2-.4-.2-.7-.2s-.5,0-.7.2-.3.3-.3.6h-1.4c0-.4,0-.7.3-1s.5-.5.8-.7.7-.2,1.2-.2,1.3.2,1.7.5.6.8.6,1.5,0,.6-.3.9-.5.5-.8.6c.4,0,.7.4.9.6s.3.6.3,1c0,.6-.2,1.1-.7,1.5s-1.1.6-1.8.6-1.3-.2-1.7-.6-.7-.9-.7-1.5h1.4c0,.3,0,.5.3.6s.4.3.7.3.6,0,.8-.3c.2-.2.3-.4.3-.7,0-.7-.4-1.1-1.2-1.1h-.7v-1.1h0l.2.2Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,78h33.2c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.7-2.7,2.7h-33.2c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M116.8,78h4c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.7-2.7,2.7h-4c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,86.8h33.2c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.7-2.7,2.7h-33.2c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-ranking-dm-cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-6",
    d: "M52.7,115.1h.8v1.1h-.8v1.5h-1.4v-1.5h-2.9v-.9l2.9-4.6h1.4v4.4h0ZM49.8,115.1h1.6v-2.5.2l-1.6,2.3h0Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,106.9h33.2c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.7-2.7,2.7h-33.2c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M116.8,106.9h4c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.7-2.7,2.7h-4c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,115.7h33.2c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.7-2.7,2.7h-33.2c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-ranking-dm-cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-6",
    d: "M48.8,143.2l.4-3.6h3.9v1.2h-2.8l-.2,1.5c.3-.2.7-.3,1.1-.3.7,0,1.2.2,1.6.6.4.4.6,1,.6,1.7s0,.9-.3,1.2c-.2.4-.5.6-.8.8-.4.2-.8.3-1.3.3s-.8,0-1.2-.3-.7-.4-.9-.7-.3-.7-.3-1.1h1.4c0,.3,0,.5.3.7s.4.2.7.2.6-.1.7-.3c.2-.2.3-.5.3-1s0-.7-.3-.9-.5-.3-.8-.3-.6,0-.8.3h0c0,.1-1.1-.2-1.1-.2h0v.2Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,135.8h33.2c1.5,0,2.7,1.2,2.7,2.6h0c0,1.5-1.2,2.7-2.7,2.7h-33.2c-1.5,0-2.7-1.2-2.7-2.6h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M116.8,135.8h4c1.5,0,2.7,1.2,2.7,2.6h0c0,1.5-1.2,2.7-2.7,2.7h-4c-1.5,0-2.7-1.2-2.7-2.6h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-dm-cls-7",
    d: "M60,144.6h33.2c1.5,0,2.7,1.2,2.7,2.6h0c0,1.5-1.2,2.7-2.7,2.7h-33.2c-1.5,0-2.7-1.2-2.7-2.6h0c0-1.5,1.2-2.7,2.7-2.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmRanking);
export default __webpack_public_path__ + "static/media/dm_ranking.6858b124.svg";
export { ForwardRef as ReactComponent };